type TEventHandler = (data: object) => void;

export const listenEvent = (eventName: string, handler: TEventHandler) => {
  document.addEventListener(eventName, (event: CustomEvent) => {
    handler({ ...event.detail });
  });
};
